<script>
import Layout from "../layouts/main";
import PageHeader from "../components/page-header";
import axios from "axios";
import { VueLoading } from "vue-loading-template";
import {
  ValidationObserver,
  ValidationProvider,
  localize,
  extend,
} from "vee-validate";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
// ルール設定
import * as rules from "vee-validate/dist/rules";
for (let rule in rules) {
  extend(rule, rules[rule]);
}
// 日本語化
import ja from "vee-validate/dist/locale/ja";
import { h } from "vue";
localize("ja", ja);

export default {
  components: {
    Layout,
    PageHeader,
    VueLoading,
    ValidationObserver,
    ValidationProvider,
    vSelect,
  },
  data() {
    return {
      id: null, // 編集時のID
      game_info_id: "", // GameInfo ID
      school_code: "", // 学校コード
      block: "", // ブロック
      no: "", // No
      rank1: "", // 選手1のランク
      rank2: "", // 選手2のランク
      name1: "", // 選手1の名前
      name2: "", // 選手2の名前
      school_year1: "", // 選手1の学年
      school_year2: "", // 選手2の学年
      sex1: "", // 選手1の性別
      sex2: "", // 選手2の性別
      recent_id: "", // 履歴ID
      search_game_info_id: "", // 検索用のGameInfo ID
      search_recent_id: "", // 検索用の履歴ID
      search_block: "", // 検索用のブロック
      tableData: [],
      title: "トーナメント", // タイトルを修正
      items: [
        {
          text: "Tournament",
          href: "/",
        },
        {
          text: "トーナメント",
          active: true,
        },
      ],
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      selectedPlayer1: "", // 選手1
      selectedPlayer2: "", // 選手2
      errors: [],
      selectAll: false,
      filterItems: [],
      filter: null,
      filterOn: [
        "draw_no",
        "school_code",
        "school_name",
        "players"
      ],
      fields: [
        {
          key: "checkbox",
          label: "",
          sortable: false,
        },
        {
          key: "draw_no", // 新しい列のキー
          label: "ドローNo.", // 列のタイトル
          sortable: false, // ソート不可
          tdClass: "minWidth100", // 列のスタイル
        },
        {
          key: "school_code",
          label: "学校コード",
          sortable: true,
          tdClass: "minWidth100",
        },
        {
          key: "school_name",
          label: "学校名",
          sortable: true,
          tdClass: "minWidth150",
        },
        {
          key: "players", // 選手情報をまとめたカスタム列
          label: "選手情報",
          sortable: false,
          tdClass: "minWidth300",
        },
        { key: "actions", label: "", sortable: false, tdClass: "minWidth100" },
      ],
      loading: false,
      mode: "list",
      gameInfos: [], // ゲーム情報一覧を格納
      recentList: [], // 履歴一覧を格納
      players: [], // プレイヤー一覧を格納
      schoolList: [], // 学校一覧を格納
      sexOptions: [
        { value: 0, text: "" }, // 空欄
        { value: 1, text: "男子" },
        { value: 2, text: "女子" },
      ],
      deleteTargetId: null,
    };
  },
  mounted() {
    this.getUser("user");

    // VuexからGameInfoIdを取得
    this.search_game_info_id = this.$store.state.gameInfoId;

    // GameInfosを取得
    this.searchItems();
  },
  computed: {
    displayedFields() {
      return this.fields; // 通常のfieldsを表示
    },
    rows() {
      return this.filterItems.length;
    },
  },
  methods: {
    // 検索
    searchItems() {
      this.loading = true;
      axios
        .get("/api/tournament", {
          params: {
            game_info_id: this.search_game_info_id,
            recent_id: this.search_recent_id, // 履歴IDを追加
            block: this.search_block, // ブロックを追加
          },
        })
        .then((response) => {
          this.loading = false;

          this.search_recent_id = response.data.recent_id; // 履歴IDを更新

          // トーナメント一覧データを設定
          this.tableData = response.data.tournaments.map((item) => {
            // 選手1情報
            const player1 = item.name1
              ? `${item.name1} ${item.school_year1 ?? ""}年 ${item.sex1 === 1 ? "男子" : item.sex1 === 2 ? "女子" : ""} 校内順位:${item.rank1 ?? ""}`
              : "";
            // 選手2情報
            const player2 = item.name2
              ? `${item.name2} ${item.school_year2 ?? ""}年 ${item.sex2 === 1 ? "男子" : item.sex2 === 2 ? "女子" : ""} 校内順位:${item.rank2 ?? ""}`
              : "";

            return {
              ...item,
              draw_no: `${item.block || ""}-${item.no || ""}`,
              players: `${player1} ${player2}`.trim(), // players列用
            };
          });

          // GameInfoデータを設定
          this.gameInfos = [
            { value: "", text: "" }, // 空白の選択肢を追加
            ...response.data.gameInfos.map((gameInfo) => {
              return {
                value: gameInfo.id,
                text: `${gameInfo.game_name} (${gameInfo.event_name})`,
              };
            }),
          ];

          // 履歴データを設定
          this.recentList = response.data.recents.map((recent) => {
            return {
              value: recent.id,
              text: `No: ${recent.no} (${recent.create_date})`,
              fix: recent.fix, // fixを追加
            };
          });

          // 存在チェック
          const exists = this.gameInfos.some(
            (gameInfo) => gameInfo.value === this.search_game_info_id
          );
          if (!exists || this.search_game_info_id === "") {
            window.location.href = "/";
          }

          // Schoolデータを設定
          this.schoolList = [
            { value: "", text: "" }, // 空白の選択肢を追加
            ...response.data.schools.map((school) => {
              return {
                value: school.school_code,
                text: `${school.school_code} : ${school.school_name}`,
              };
            }),
          ];

          // Playerデータを設定
          this.players = [
            { value: "", text: "" }, // 空白の選択肢を追加
            ...response.data.players.map((player) => {
              return {
                value: player.name,
                text: `${player.name} (学年：${player.school_year ?? ""}, 性別：${player.sex === 1 ? "男子" : player.sex === 2 ? "女子" : ""}, 校内順位：${player.rank ?? ""})`,
                school_code: player.school_code, // school_codeを追加
                name: player.name, // nameを追加
              };
            }),
          ];

          this.filterItems = this.tableData;
          this.selectAll = false;
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
        });
    },
    // 削除
    deleteItems() {
      this.loading = true;
      let list = this.tableData.filter((item) => item.selected);
      let ids = [];
      list.forEach((item) => {
        ids.push(item.id);
      });
      axios
        .post("/api/tournament/delete", {
          ids: ids,
        })
        .then((response) => {
          this.loading = false;
          this.searchItems();
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
        });
    },
    openDeleteModal(id) {
      this.deleteTargetId = id; // 削除対象のIDを設定
      this.$bvModal.show("modal-delete-recent"); // モーダルを表示
    },
    deleteRecent(item) {
      this.loading = true;
      axios
        .post("/api/tournament/recent/delete", { id: this.deleteTargetId }) // APIエンドポイントとパラメータを設定
        .then(() => {
          this.loading = false;
          this.searchItems(); // 削除後にリストを再取得
          this.deleteTargetId = null;
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error); // エラーハンドリング
          this.deleteTargetId = null;
        });
    },
    // 追加
    add() {
      this.mode = "add";
      this.id = "new";
      this.game_info_id = this.search_game_info_id;
      this.recent_id = this.search_recent_id;
      this.school_code = "";
      this.block = "";
      this.no = "";
      this.rank1 = "";
      this.rank2 = "";
      this.name1 = "";
      this.name2 = "";
      this.school_year1 = "";
      this.school_year2 = "";
      this.sex1 = "";
      this.sex2 = "";
    },
    // 編集
    edit(item) {
      this.mode = "edit";
      this.id = item.id;
      this.game_info_id = item.game_info_id;
      this.recent_id = item.recent_id;
      this.school_code = item.school_code;
      this.block = item.block;
      this.no = item.no;
      this.rank1 = item.rank1;
      this.rank2 = item.rank2;
      this.name1 = item.name1;
      this.name2 = item.name2;
      this.school_year1 = item.school_year1;
      this.school_year2 = item.school_year2;
      this.sex1 = item.sex1;
      this.sex2 = item.sex2;
    },
    // 確定
    submit() {
      let formData = new FormData();

      formData.append("id", this.id);
      formData.append("game_info_id", this.game_info_id || "");
      formData.append("recent_id", this.recent_id || "");
      formData.append("school_code", this.school_code || "");
      formData.append("block", this.block || "");
      formData.append("no", this.no || "");
      formData.append("rank1", this.rank1 || "");
      formData.append("rank2", this.rank2 || "");
      formData.append("name1", this.name1 || "");
      formData.append("name2", this.name2 || "");
      formData.append("school_year1", this.school_year1 || "");
      formData.append("school_year2", this.school_year2 || "");
      formData.append("sex1", this.sex1 || "");
      formData.append("sex2", this.sex2 || "");

      let config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };

      this.loading = true;
      axios
        .post("/api/tournament/update", formData, config)
        .then((res) => {
          this.loading = false;
          this.searchItems();
          this.mode = "list";
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
        });
    },
    // 抽選
    draw() {
      let formData = new FormData();

      formData.append("game_info_id", this.search_game_info_id || "");
      formData.append("recent_id", this.search_recent_id || "");

      let config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };

      this.loading = true;
      axios
        .post("/api/tournament/draw", formData, config)
        .then((res) => {
          this.loading = false;
          if (res.data && res.data.recent_id) {
            this.search_recent_id = res.data.recent_id; // recent_idをセット
          }
          this.searchItems();
          this.mode = "list";
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
        });
    },
    // 確定
    updateFix($recent_id) {
      let formData = new FormData();

      formData.append("game_info_id", this.search_game_info_id || "");
      formData.append("recent_id", $recent_id || "");

      let config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };

      this.loading = true;
      axios
        .post("/api/tournament/recent/fix", formData, config)
        .then((res) => {
          this.loading = false;
          this.searchItems();
          this.mode = "list";
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
        });
    },
    onFiltered(items) {
      this.filterItems = items;
    },
    formatDate(date) {
      if (!date) return ""; // nullまたはundefinedの場合は空欄を返す
      const options = { year: "numeric", month: "2-digit", day: "2-digit" };
      return new Date(date).toLocaleDateString("ja-JP", options);
    },
    exportTournament() {
      axios
        .get("/api/tournament/export/tournament", {
          params: {
            game_info_id: this.search_game_info_id || null, // search_game_info_idを条件として渡す
            recent_id: this.search_recent_id || null, // search_recent_idを条件として渡す
          },
          responseType: "blob", // バイナリデータを取得
        })
        .then((response) => {
          let fileName = "トーナメント表.xlsx";

          // ファイルをダウンロード
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          this.errorProcess(error);
        });
    },
    exportNukidashi() {
      axios
        .get("/api/tournament/export/nukidashi", {
          params: {
            game_info_id: this.search_game_info_id || null, // search_game_info_idを条件として渡す
            recent_id: this.search_recent_id || null, // search_recent_idを条件として渡す
          },
          responseType: "blob", // バイナリデータを取得
        })
        .then((response) => {
          let fileName = "抜出表.xlsx";

          // ファイルをダウンロード
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          this.errorProcess(error);
        });
    },
    rowClass(item) {
      return item.value == this.search_recent_id ? "highlight-row" : "";
    },
    onRecentSelected(item) {
      this.search_recent_id = item.value;
      this.searchItems();
    },
    goToGameInfo() {
      window.location.href = "/game-info";
    },
  },
  watch: {
    selectAll: function (newValue, oldValue) {
      this.filterItems.forEach((item) => {
        item.selected = this.selectAll;
      });
    },
  },
};
</script>

<style>
.minWidth100 {
  min-width: 100px;
  word-break: break-all;
}

.minWidth200 {
  min-width: 200px;
  word-break: break-all;
}

.minWidth150 {
  min-width: 150px;
  word-break: break-all;
}

.minWidth300 {
  min-width: 300px;
  word-break: break-all;
}

.highlight-row td,
.highlight-row th {
  background-color: #f0f0f0 !important;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!-- リスト -->
    <div class="row" v-if="mode == 'list'">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row me-2">
              <div class="col-sm-12 col-md-6">
                <b-form-group label="大会情報" label-cols-sm="3">
                  <b-form-select v-model="search_game_info_id" :options="gameInfos" @change="searchItems"
                    class="form-select" disabled></b-form-select>
                </b-form-group>
                <b-form-group label="ブロック" label-cols-sm="3" class="mt-3">
                  <div class="d-flex align-items-center">
                    <b-form-input v-model="search_block" type="text" class="form-control"
                      style="width: 100px"></b-form-input>
                    <b-button class="ms-3" variant="primary" @click="searchItems">
                      検索
                    </b-button>
                  </div>
                </b-form-group>
              </div>
              <div class="col-sm-12 col-md-6">
                <b-form-group label="履歴" label-cols-sm="3">
                  <b-table hover :items="recentList"
                    :fields="[{ key: 'text', label: '履歴' }, { key: 'fix', label: '', tdClass: 'text-end' }, { key: 'actions', label: '', tdClass: 'text-end' }]"
                    responsive="sm" @row-clicked="onRecentSelected" :tbody-tr-class="rowClass" thead-class="d-none"
                    style="cursor: pointer;">
                    <template v-slot:cell(fix)="data">
                      <span v-if="data.item.fix === 1">★</span>
                    </template>
                    <template v-slot:cell(actions)="data">
                      <button class="btn btn-sm btn-outline-danger my-0 py-0 me-1"
                        @click="openDeleteModal(data.item.value)">
                        削除
                      </button>
                      <button class="btn btn-sm btn-outline-primary my-0 py-0" @click="updateFix(data.item.value)">
                        確定
                      </button>
                    </template>
                  </b-table>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <label class="ms-1 mb-0 pb-0">件数：{{ filterItems.length }}</label>
            </div>
            <hr class="mt-1 pt-0" />
            <div class="row mt-3">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center" style="white-space: nowrap">
                    表示&nbsp;
                    <b-form-select v-model="perPage" size="sm" class="form-select form-select-sm"
                      :options="pageOptions"></b-form-select>&nbsp;行
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div class="text-md-end">
                  <label class="d-inline-flex align-items-center" style="white-space: nowrap">
                    フィルタ:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control ms-2"></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive">
              <b-table striped hover :items="tableData" :fields="displayedFields" responsive="sm" :per-page="perPage"
                :current-page="currentPage" :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered">
                <template v-slot:head(checkbox)="{ item }">
                  <b-form-group>
                    <b-form-checkbox plain v-model="selectAll">
                    </b-form-checkbox>
                  </b-form-group>
                </template>
                <template v-slot:cell(checkbox)="{ item }">
                  <b-form-group>
                    <b-form-checkbox plain v-model="item.selected" class="mr-1">
                    </b-form-checkbox>
                  </b-form-group>
                </template>
                <template v-slot:cell(players)="{ item }">
                  <div>
                    <span v-if="String(item.name1).toLowerCase() === 'bye'">
                      <strong>Bye</strong></span>
                    <template v-else>
                      <!-- 選手1の情報を表示（player1が存在する場合のみ） -->
                      <div v-if="item.name1">
                        <strong>選手１：</strong>
                        {{ item.name1 }}
                        (学年：{{ item.school_year1 }}年, 性別：
                        {{ item.sex1 === 1 ? '男子' : (item.sex1 === 2 ? '女子' : '') }},
                        校内順位： {{ item.rank1 }})
                      </div>
                      <!-- 選手2の情報を表示（player2が存在する場合のみ） -->
                      <div v-if="item.name2">
                        <strong>選手２：</strong>
                        {{ item.name2 }}
                        (学年：{{ item.school_year2 }}年, 性別：
                        {{ item.sex2 === 1 ? '男子' : (item.sex2 === 2 ? '女子' : '') }},
                        校内順位： {{ item.rank2 }})
                      </div>
                    </template>
                  </div>
                </template>
                <template v-slot:cell(actions)="{ item }">
                  <span>
                    <button class="btn btn-sm btn-outline-primary" @click="edit(item)">
                      編集
                    </button>
                  </span>
                </template>
              </b-table>
            </div>
            <div class="row mb-3">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-12 mb-3">
                <div id="tickets-table_filter" class="text-md-end">
                  <button class="btn btn-danger me-2" type="button" v-b-modal.modal-delete>
                    削除
                  </button>
                  <button class="btn btn-primary me-4" type="button" @click="add">
                    追加
                  </button>
                  <button class="btn btn-primary me-2" type="button" @click="draw">
                    抽選
                  </button>
                  <button class="btn btn-success me-2" @click="exportTournament">トーナメント出力</button>
                  <button class="btn btn-success me-2" @click="exportNukidashi">抜出表出力</button>
                  <b-button variant="primary" @click="goToGameInfo">戻る</b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- 追加・編集 -->
    <div class="row" v-if="mode == 'add' || mode == 'edit'">
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              {{ mode == "add" ? "新規登録" : "編集" }}
            </h4>
            <ValidationObserver ref="obs" v-slot="ObserverProps">
              <b-form>
                <div class="row">
                  <div class="col-lg-12">
                    <b-form-group label="大会情報" label-cols-sm="3">
                      <ValidationProvider name="大会情報" :rules="{ required: true }">
                        <div slot-scope="ProviderProps">
                          <b-form-select plain v-model="game_info_id" :options="gameInfos" disabled></b-form-select>
                          <p class="text-danger mb-2">
                            {{ ProviderProps.errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                    <b-form-group label="ドローNo." label-cols-sm="3">
                      <div class="d-flex align-items-center mt-1">
                        <ValidationProvider name="ブロック" :rules="{ required: true, regex: /^[0-9]{0,4}$/ }">
                          <div slot-scope="ProviderProps" class="me-3">
                            <label for="block">ブロック</label>
                            <b-form-input id="block" type="text" v-model="block" placeholder="ブロック" style="width: 100px"
                              autocomplete="off"></b-form-input>
                            <p class="text-danger mb-2">{{ ProviderProps.errors[0] }}</p>
                          </div>
                        </ValidationProvider>
                        <ValidationProvider name="No" :rules="{ required: true, regex: /^[0-9]{0,4}$/ }">
                          <div slot-scope="ProviderProps">
                            <label for="no">No</label>
                            <b-form-input id="no" type="text" v-model="no" placeholder="No" style="width: 100px"
                              autocomplete="off"></b-form-input>
                            <p class="text-danger mb-2">{{ ProviderProps.errors[0] }}</p>
                          </div>
                        </ValidationProvider>
                      </div>
                    </b-form-group>
                    <b-form-group label="学校コード" label-cols-sm="3">
                      <ValidationProvider name="学校コード" :rules="{ required: false }">
                        <div slot-scope="ProviderProps">
                          <b-form-select v-model="school_code" :options="schoolList" placeholder="学校を選択"
                            class="form-select" style="width: 200px"></b-form-select>
                          <p class="text-danger mb-2">
                            {{ ProviderProps.errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                    <b-form-group label="選手1" label-cols-sm="3">
                      <ValidationProvider name="選手1の名前" :rules="{ required: true }">
                        <div slot-scope="ProviderProps">
                          <label for="name1" class="mt-1">名前</label>
                          <b-form-input id="name1" type="text" v-model="name1" style="width: 300px"
                            autocomplete="off"></b-form-input>
                          <p class="text-danger mb-2">{{ ProviderProps.errors[0] }}</p>
                        </div>
                      </ValidationProvider>
                      <div class="d-flex align-items-center">
                        <ValidationProvider name="選手1の学年" :rules="{ regex: /^[0-9]{1,2}$/ }">
                          <div slot-scope="ProviderProps" class="me-3">
                            <label for="school_year1">学年</label>
                            <b-form-input id="school_year1" type="text" v-model="school_year1" placeholder="学年"
                              style="width: 100px" autocomplete="off"></b-form-input>
                            <p class="text-danger mb-2">{{ ProviderProps.errors[0] }}</p>
                          </div>
                        </ValidationProvider>
                        <ValidationProvider name="選手1の性別" :rules="{ required: false }">
                          <div slot-scope="ProviderProps" class="me-3">
                            <label for="sex1">性別</label>
                            <b-form-select id="sex1" v-model="sex1" :options="sexOptions" placeholder="性別"
                              class="form-select" style="width: 150px"></b-form-select>
                            <p class="text-danger mb-2">{{ ProviderProps.errors[0] }}</p>
                          </div>
                        </ValidationProvider>
                        <ValidationProvider name="選手1の校内順位" :rules="{ regex: /^[0-9]{1,4}$/ }">
                          <div slot-scope="ProviderProps">
                            <label for="rank1">校内順位</label>
                            <b-form-input id="rank1" type="text" v-model="rank1" placeholder="順位" style="width: 100px"
                              autocomplete="off"></b-form-input>
                            <p class="text-danger mb-2">{{ ProviderProps.errors[0] }}</p>
                          </div>
                        </ValidationProvider>
                      </div>
                    </b-form-group>
                    <b-form-group label="選手2" label-cols-sm="3">
                      <ValidationProvider name="選手2の名前" :rules="{ required: false }">
                        <div slot-scope="ProviderProps">
                          <label for="name2" class="mt-1">名前</label>
                          <b-form-input id="name2" type="text" v-model="name2" style="width: 300px"
                            autocomplete="off"></b-form-input>
                          <p class="text-danger mb-2">{{ ProviderProps.errors[0] }}</p>
                        </div>
                      </ValidationProvider>
                      <div class="d-flex align-items-center">
                        <ValidationProvider name="選手2の学年" :rules="{ regex: /^[0-9]{1,2}$/ }">
                          <div slot-scope="ProviderProps" class="me-3">
                            <label for="school_year2">学年</label>
                            <b-form-input id="school_year2" type="text" v-model="school_year2" placeholder="学年"
                              style="width: 100px" autocomplete="off"></b-form-input>
                            <p class="text-danger mb-2">{{ ProviderProps.errors[0] }}</p>
                          </div>
                        </ValidationProvider>
                        <ValidationProvider name="選手2の性別" :rules="{ required: false }">
                          <div slot-scope="ProviderProps" class="me-3">
                            <label for="sex2">性別</label>
                            <b-form-select id="sex2" v-model="sex2" :options="sexOptions" placeholder="性別"
                              class="form-select" style="width: 150px"></b-form-select>
                            <p class="text-danger mb-2">{{ ProviderProps.errors[0] }}</p>
                          </div>
                        </ValidationProvider>
                        <ValidationProvider name="選手2の校内順位" :rules="{ regex: /^[0-9]{1,4}$/ }">
                          <div slot-scope="ProviderProps">
                            <label for="rank2">校内順位</label>
                            <b-form-input id="rank2" type="text" v-model="rank2" placeholder="順位" style="width: 100px"
                              autocomplete="off"></b-form-input>
                            <p class="text-danger mb-2">{{ ProviderProps.errors[0] }}</p>
                          </div>
                        </ValidationProvider>
                      </div>
                    </b-form-group>
                  </div>
                </div>
                <div class="row mt-2">
                  <div>
                    <b-button class="me-2" variant="primary" :disabled="ObserverProps.invalid"
                      @click="submit">確定</b-button>
                    <b-button variant="primary" @click="mode = 'list'">戻る</b-button>
                  </div>
                </div>
              </b-form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
    <!-- 削除 -->
    <b-modal id="modal-delete" title="確認" title-class="font-18" @ok="deleteItems">
      <p>選択されたデータを削除してよろしいですか？</p>
    </b-modal>
    <b-modal id="modal-delete-recent" title="確認" title-class="font-18" @ok="deleteRecent">
      <p>選択された履歴を削除してよろしいですか？</p>
    </b-modal>
    <div v-if="loading" class="modal-mask">
      <vue-loading type="spiningDubbles" color="#eee" :size="{ width: '50px', height: '50px' }"></vue-loading>
    </div>
  </Layout>
</template>
